export const CssVariablesTheme = {
    // Header
    headerColor: '#888888',
    headerBackground: '#ffffff',
    headerApplyBtnBg: 'transparent',
    headerApplyBtnBorderColor: '#A5314F',
    headerApplyBtnColor: '#000000',
    headerFontSize: '18px',
    headerActiveLinkColor: '#000000',
    logoMaxSize: '100%',

    /* Body*/
    formTextColor: '#000000',
    background: '#ffffff',
    font: 'Myriad Pro',
    fontSize: '18px',
    itemListBg: '#F5F5F5',
    basePageWidth: '',
    basePageMaxWidth: '',

    /* Form*/
    labelColor: '#888888',
    inputBorderColor: '#DDDDDD',
    inputBg: '#ffffff',
    inputBorderColorHover: '#C98A98',
    inputBorderRadius: '8px',
    formButtonsBg: '#A5314F',
    formButtonsColor: '#FFFFFF',
    tabsColor: '#888888',
    calculatorSecondaryText: '#888888',
    calculatorSliderTrack: '#A5314F',
    calculatorInputColor: '#000000',
    calculatorSliderHandleBg: '#A5314F',
    calculatorSliderHandleBorder: '#C98A98',
    tabsBorderBottomColor: '#DDDDDD',
    activeTabColor: '#A5314F',
    activeTabBorderColor: '#A5314F',

    /* Footer*/
    footerBg: '#ffffff',
    footerTextColor: '#888888',

    /* Statuses color */
    pending: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    active: {
        color: '#000000',
        borderColor: '#39917F',
        backgroundColor: '#39917F',
    },
    repaid: {
        color: '#000000',
        borderColor: '#39917F',
        backgroundColor: '#39917F',
    },
    overdue: {
        color: '#000000',
        borderColor: '#E56855',
        backgroundColor: '#E56855',
    },
    writtenOff: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    processing: {
        color: '#000000',
        borderColor: '#E3DB40',
        backgroundColor: '#E3DB40',
    },
    error: {
        color: '#000000',
        borderColor: '#E56855',
        backgroundColor: '#E56855',
    },
    onKyc: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    verification: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    updateRequested: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    underwriting: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    declined: {
        color: '#000000',
        borderColor: '#E56855',
        backgroundColor: '#E56855',
    },
    canceled: {
        color: '#000000',
        borderColor: '#E56855',
        backgroundColor: '#E56855',
    },
    approved: {
        color: '#000000',
        borderColor: '#39917F',
        backgroundColor: '#39917F',
    },
    disbursed: {
        color: '#000000',
        borderColor: '#39917F',
        backgroundColor: '#39917F',
    },
    advancedConsent: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    awaitingAdvanced: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    awaitingConsent: {
        color: '#000000',
        borderColor: '#E56855',
        backgroundColor: '#E56855',
    },
    dentalTreatment: {
        color: '#000000',
        borderColor: '#39917F',
        backgroundColor: '#39917F',
    },
    firstStage: {
        color: '#000000',
        borderColor: '#39917F',
        backgroundColor: '#39917F',
    },
    consentExpired: {
        color: '#000000',
        borderColor: '#E56855',
        backgroundColor: '#E56855',
    },
    consentConfirmation: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    statusColorsRepaid: {
        color: '#000000',
        borderColor: '#39917F',
        backgroundColor: '#39917F',
    },
    statusColorsWrittenOff: {
        color: '#000000',
        borderColor: '#9EA3AE',
        backgroundColor: '#9EA3AE',
    },
    statusColorsProcessing: {
        color: '#000000',
        borderColor: '#dbd053',
        backgroundColor: '#dbd053',
    },

    isFilledStatus: false,
};
